import React from 'react';
import {LANGUAGES, localePath} from '../../languages';
import config from '../../config';

const origin = config.homeUrl.replace(/\/$/, '');

export default function seoLinks(path, lang) {
    return [
        <link key="canonical" rel="canonical" href={`${origin}${localePath(path, lang)}`}/>,
        ...LANGUAGES.map(({code}) => (
            <link key={code} rel="alternate" hrefLang={code} href={`${origin}${localePath(path, code)}`}/>
        )),
        <link key="x-default" rel="alternate" hrefLang="x-default" href={`${origin}${path}`}/>,
    ];
}
